import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { COMMUNITY_REQUEST_FORM_URL } from '../../misc/Constants'
import { hasCommunity } from '../../utility/userHelper'
import { stockAccolades } from '../../accolades/accolades'

import classes from './AllSetCard.module.scss'

const AllSetCard = ({ coach }) => {
  const { t } = useTranslation()
  const withCommunity = hasCommunity(coach)
  const nextStepClassName = coach.certified ? classNames('btn btn-primary text-white mt-4', classes.button) : classNames('mt-3', classes.link)
  const nextStep = withCommunity
    ? <Link to='/dashboard' className={nextStepClassName}>{t('portal.allSet.communityDashboard')}</Link>
    : (
      <a href={COMMUNITY_REQUEST_FORM_URL} target='_blank' rel='noopener noreferrer' className={nextStepClassName}>
        {t('portal.allSet.requestAccess')}
        <i className='fa fa-external-link ml-2' aria-hidden='true' />
      </a>
    )

  return (
    <section className={classNames('d-flex flex-column align-items-center text-center', classes.card)}>
      {coach.certified ? (
        <span className={classNames('d-flex align-items-center justify-content-center', classes.badge)}>
          <img src={stockAccolades.Certified.badge} alt='' className={classes.badgeImage} />
        </span>
      ) : (
        <span className={classNames('d-flex align-items-center justify-content-center', classes.checkIcon)}>
          <i className='fa fa-check' aria-hidden='true' />
        </span>
      )}
      <span className={classNames('mt-4', classes.eyebrow)}>
        {coach.certified ? t('portal.badges.certified') : t('portal.allSet.notCertifiedEyebrow')}
      </span>
      <h3 className={classNames('mt-2 mb-2', classes.headline)}>{t('portal.allSet.title')}</h3>
      <p className={classNames('mb-0', classes.text)}>
        {coach.certified
          ? t(withCommunity ? 'portal.allSet.communityBody' : 'portal.allSet.requestBody')
          : t('portal.allSet.notCertifiedBody')}
      </p>
      {!coach.certified && (
        <Link to='/portal/certifications' className={classNames('btn btn-primary text-white mt-4', classes.button)}>
          <i className='fa fa-graduation-cap mr-2' aria-hidden='true' />
          {t('portal.allSet.getCertified')}
        </Link>
      )}
      {nextStep}
    </section>
  )
}

AllSetCard.propTypes = {
  coach: PropTypes.shape({ certified: PropTypes.bool, communities: PropTypes.array }).isRequired,
}

export default AllSetCard
